import { createContext, useContext, useEffect, useState } from 'react';

const FormReadOnlyContext = createContext(false);
export const FormReadOnlyProvider = FormReadOnlyContext.Provider;
export const useFormReadOnly = () => useContext(FormReadOnlyContext);

/**
 * Returns true briefly after `useFormReadOnly()` toggles, then false again.
 * Lets components gate CSS transitions so they only animate on the read-only
 * toggle and not on unrelated state changes (e.g. adding/removing combobox chips).
 */
export function useIsTogglingReadOnly(durationMs = 250): boolean {
	const formReadOnly = useFormReadOnly();
	const [isToggling, setIsToggling] = useState(false);
	const [prev, setPrev] = useState(formReadOnly);
	if (prev !== formReadOnly) {
		setPrev(formReadOnly);
		setIsToggling(true);
	}
	useEffect(() => {
		if (!isToggling) return;
		const t = setTimeout(() => setIsToggling(false), durationMs);
		return () => clearTimeout(t);
	}, [isToggling, durationMs]);
	return isToggling;
}
